<rtr-dialog-wrapper>
  <ng-container title>
    {{ 'EditUserDialog.Title' | translate }}
  </ng-container>

  <ng-container content>
    <div class="fxcolumn">
      <span class="title">{{ 'EditUserDialog.First name' | translate }}</span>
      <span class="description margin-b-m">{{ data.details.firstName ? data.details.firstName : '-' }}</span>
      <span class="title">{{ 'EditUserDialog.Last name' | translate }}</span>
      <span class="description margin-b-m">{{ data.details.lastName ? data.details.lastName : '-' }}</span>
      <span class="title">{{ 'EditUserDialog.e-mail' | translate }}</span>
      <span class="description margin-b-m">{{ data.details.email ? data.details.email : '-' }}</span>
      <span class="title">{{ 'EditUserDialog.Role' | translate }}</span
      ><span class="description margin-b-m"> {{ UserRoleName[data.role] }}</span>
    </div>
  </ng-container>

  <ng-container actions>
    <rtr-button type="secondary" text="Rewrite.Cancel" class="close-user-dialog" (click)="cancel()" />
  </ng-container>
</rtr-dialog-wrapper>
